import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";

/**
 * 枚举类
 * @Author: zwr
 * @Date: 2019-07-15 18:43:47
 * @Last Modified by:   Amanda
 * @Last Modified time: 2019-07-15 18:43:47
 * @Remark:
 */

/*
	文章内容类型管理
	内容类型 0:图文，5:音频，10：视频，15:模板，20:下载包
 */
export function contentType(type) {
  var types = [{
    code: 0,
    text: '图文',
    key: 'textImg'
  }, {
    code: 5,
    text: '音频',
    key: 'audio'
  }, {
    code: 10,
    text: '视频',
    key: 'video'
  }, {
    code: 15,
    text: '模板',
    key: 'template'
  }, {
    code: 20,
    text: '下载包',
    key: 'downPack'
  }];
  return filter(type, types);
}
/*
	性别
	内容类型 0:男，1:女
 */

export function gender(type) {
  var types = [{
    code: 1,
    text: '男',
    key: 'man'
  }, {
    code: 2,
    text: '女',
    key: 'women'
  }];
  return filter(type, types);
} // 是 或 否

export function isOrNoMap(type) {
  var types = [{
    code: 1,
    text: '是',
    key: 'is'
  }, {
    code: 0,
    text: '否',
    key: 'no'
  }];
  return filter(type, types);
}

function filter(type, types) {
  if (!type) {
    return types;
  }

  var target = {};
  types.map(function (item) {
    Object.keys(item).map(function (n) {
      if (item[n] === type) {
        target = item;
      }
    });
  });
  return target;
}